import { useMedia } from 'react-use';
import { lgStartMedia, mdMedia } from '../../constants';
export var ViewportSizes;
(function (ViewportSizes) {
    ViewportSizes["large"] = "large";
    ViewportSizes["medium"] = "medium";
    ViewportSizes["small"] = "small";
})(ViewportSizes || (ViewportSizes = {}));
export function useViewportBreakpoints({ ssr = true, } = {}) {
    const isLarge = useMedia(lgStartMedia, ssr ? false : undefined);
    const isMedium = useMedia(mdMedia, ssr ? false : undefined);
    return ((isLarge && ViewportSizes.large) || (isMedium && ViewportSizes.medium) || ViewportSizes.small);
}
//# sourceMappingURL=useViewportBreakpoints.js.map